var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.002,
    height: 64.002,
    viewBox: "0 0 64.002 64.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54576",
    "data-name": "Group 54576",
    transform: "translate(3421 15912)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16761",
    "data-name": "Rectangle 16761",
    width: 64.002,
    height: 64.002,
    transform: "translate(-3421 -15912)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lock_FILL0_wght400_GRAD0_opsz24",
    d: "M166.095-856.006a5.869,5.869,0,0,1-4.3-1.79,5.869,5.869,0,0,1-1.79-4.3v-30.474a5.869,5.869,0,0,1,1.79-4.3,5.868,5.868,0,0,1,4.3-1.79h3.047v-6.095a14.685,14.685,0,0,1,4.457-10.78A14.684,14.684,0,0,1,184.379-920a14.684,14.684,0,0,1,10.78,4.457,14.685,14.685,0,0,1,4.457,10.78v6.095h3.047a5.868,5.868,0,0,1,4.3,1.79,5.868,5.868,0,0,1,1.79,4.3V-862.1a5.869,5.869,0,0,1-1.79,4.3,5.869,5.869,0,0,1-4.3,1.79Zm0-6.094h36.568v-30.474H166.095Zm18.284-9.142a5.869,5.869,0,0,0,4.3-1.79,5.869,5.869,0,0,0,1.79-4.3,5.868,5.868,0,0,0-1.79-4.3,5.869,5.869,0,0,0-4.3-1.791,5.869,5.869,0,0,0-4.3,1.791,5.868,5.868,0,0,0-1.79,4.3,5.868,5.868,0,0,0,1.79,4.3A5.869,5.869,0,0,0,184.379-871.242Zm-9.142-27.426h18.284v-6.095a8.816,8.816,0,0,0-2.666-6.476,8.817,8.817,0,0,0-6.476-2.666,8.817,8.817,0,0,0-6.476,2.666,8.816,8.816,0,0,0-2.666,6.476ZM166.095-862.1v0Z",
    transform: "translate(-3573.378 -14992)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3e63a7702e0cba1ec5c96313acbac587.svg";
export { ForwardRef as ReactComponent };